import { render, staticRenderFns } from "./ProjectTime.vue?vue&type=template&id=af5723a2&scoped=true&"
import script from "./ProjectTime.vue?vue&type=script&lang=ts&"
export * from "./ProjectTime.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTime.vue?vue&type=style&index=0&id=af5723a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5723a2",
  null
  
)

export default component.exports